export default __webpack_public_path__ + "static/media/single-project-page-02-img4.d16e57f0.jpg";